import React, { useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import Commons from '../../Services/Common/Common';

function Canvas({
  signatureCanvas,
  userId,
  imageUrl,
  disabled,
  onEnd = (e) => {},
}) {
  useEffect(() => {
    // 텍스트를 추가하는 함수
    // const addTextToCanvas = (canvas, text) => {
    //     const ctx = canvas.getContext('2d');
    //     ctx.font = '6rem Arial';
    //     ctx.fillStyle = 'black';
    //     ctx.fillStyle = 'rgba(0, 0, 0, 0.2)'; // 연한 검은색 설정
    //     // 텍스트의 폭을 계산
    //     const textWidth = ctx.measureText(text).width;
    //     // 텍스트의 위치를 계산 (캔버스 중앙)
    //     const x = (canvas.width - textWidth) / 2;
    //     // 200px 폰트의 경우 텍스트의 높이를 고려하여 y 좌표를 설정
    //     // 텍스트 높이는 폰트 크기의 75% 정도를 중앙 높이로 사용
    //     const y = (canvas.height + 60) / 2;
    //     ctx.fillText(text, x, y);
    // };
    // const canvas = signatureCanvas.current.getCanvas();
    // addTextToCanvas(canvas, userId);
    signatureCanvas.current.on();

    if (signatureCanvas.current) {
      // imageUrl이 있을 때만 이미지를 로드
      if (imageUrl) {
        signatureCanvas.current.fromDataURL(imageUrl);
      } else {
        // imageUrl이 없으면 캔버스 클리어
        signatureCanvas.current.clear();
      }

      // 그리기 비활성화 (읽기 전용으로)
      disabled && signatureCanvas.current.off();
    }
  }, [disabled, imageUrl]);

  const clearCanvas = () => {
    signatureCanvas.current.clear();
  };

  return (
    // <Card
    //     sx={{
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //         p: 0,
    //         border: 'solid 2px #D0DBD1',
    //         width: '100%',
    //     }}
    // >
    <Stack
      sx={{
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SignatureCanvas
        ref={signatureCanvas}
        penColor="black" // 진하게
        minWidth={5} //선 최소 두께
        maxWidth={5} //선 최대 두께
        throttle={0}
        canvasProps={{
          className: 'sigCanvas canvasStyle',
          style: {
            height: Commons.IsMobile() ? 150 : 250,
            width: Commons.IsMobile() ? '100%' : 700,
            borderRadius: '8px',
            backgroundColor: disabled ? 'rgba(0, 0, 0, 0.12)' : '#E4EFED',
            border: '1px solid #ccc',
            // 바텀시트 세로 드래그와 터치가 겹치지 않도록
            touchAction: 'none',
          },
        }}
        onEnd={onEnd}
      />

      <Typography
        variant="Kor_24_b"
        sx={{
          fontSize: '3rem',
          position: 'absolute',
          pointerEvents: 'none',
          color: 'rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
          width: '73%',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'pre-wrap',
        }}
      >
        {userId}
      </Typography>
    </Stack>
    // </Card>
  );
}

export default Canvas;
